import axios from 'axios';

import {
  ResearchPerfEvalCriteria,
  ResearchPerfEvalCriteriaData,
  ResearchPerfEvalCriteriaDataItemRequest,
  ResearchPerfEvalItemOption,
  ResearchPerfEvalReport,
  ResearchPerfEvalReportAuthor,
} from '@/module/ResearchPerfEval/model/ResearchPerfEvalTypes';

import { Id, getData } from '@feature/utils';

export function getResearchPerfEvalItemFileDownloadUrl(evaluationId: Id, authorId: Id, orderNo: number, itemId: Id) {
  return `/api/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}/item/${itemId}/file-download`;
}

export function getAll() {
  return axios.get<ResearchPerfEvalReport[]>(`/research-perf-evaluation`).then(getData);
}

export function get(evaluationId: Id) {
  return axios.get<ResearchPerfEvalReport>(`/research-perf-evaluation/${evaluationId}`).then(getData);
}

export function open(year: number) {
  return axios.post<unknown>(`/research-perf-evaluation/${year}/open`).then(getData);
}

export function getCriteria(evaluationId: Id) {
  return axios.get<ResearchPerfEvalCriteria[]>(`/research-perf-evaluation/${evaluationId}/criteria`).then(getData);
}

export function start(evaluationId: Id) {
  return axios.put<unknown>(`/research-perf-evaluation/${evaluationId}/author/start`).then(getData);
}

export function getForAuthor(evaluationId: Id, authorId: Id) {
  return axios
    .get<ResearchPerfEvalReportAuthor | null>(`/research-perf-evaluation/${evaluationId}/author/${authorId}`)
    .then(getData)
    .then(data => (!data ? null : data));
}

export function getCriteriaData(evaluationId: Id, authorId: Id, orderNo: number) {
  return axios
    .get<ResearchPerfEvalCriteriaData>(
      `/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}`,
    )
    .then(getData);
}

export function addCriteriaItem(
  evaluationId: Id,
  authorId: Id,
  orderNo: number,
  request: ResearchPerfEvalCriteriaDataItemRequest,
) {
  const formData = new FormData();
  if (request.newFile != null) {
    formData.append('file', request.newFile);
  }
  formData.append('payload', new Blob([JSON.stringify(request)], { type: 'application/json' }));
  return axios
    .post<unknown>(`/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}/item`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function editCriteriaItem(
  evaluationId: Id,
  authorId: Id,
  orderNo: number,
  itemId: Id,
  request: ResearchPerfEvalCriteriaDataItemRequest,
) {
  const formData = new FormData();
  if (request.newFile != null) {
    formData.append('file', request.newFile);
  }
  formData.append('payload', new Blob([JSON.stringify(request)], { type: 'application/json' }));
  return axios
    .put<unknown>(
      `/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}/item/${itemId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then(getData);
}

export function deleteCriteriaItem(evaluationId: Id, authorId: Id, orderNo: number, itemId: Id) {
  return axios
    .delete(`/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}/item/${itemId}`)
    .then(getData);
}

export function getPossibleItemOptions<T>(evaluationId: Id, authorId: Id, orderNo: number) {
  return axios
    .get<
      ResearchPerfEvalItemOption<T>[]
    >(`/research-perf-evaluation/${evaluationId}/author/${authorId}/criteria/${orderNo}/possible-options`)
    .then(getData);
}
